import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { FiMenu } from 'react-icons/fi';
import { useAuth } from '../../finance/auth/AuthContext';
import { normalizeRole } from '../../finance/auth/permissions';
import NotificationDropdown from './NotificationDropdown';

// import OnboardingModal from '../OnboardingModal';

const MainLayout = ({ children, pageTitle, actions }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { username, role } = useAuth();

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const toggleCollapse = () => setIsCollapsed(!isCollapsed);

  // Generate a title based on route if not provided
  const getDynamicTitle = () => {
    if (pageTitle) return pageTitle;
    const path = location.pathname.split('/').pop();
    if (!path || path === '') return 'Dashboard';
    // Convert 'leave-approvals' to 'Leave Approvals'
    const title = path.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    
    if (title === 'EmpProducts') return 'Products';
    
    return title;
  };

  return (
    <div className="flex h-screen w-full bg-slate-50 overflow-hidden font-sans text-slate-800">
      {/* <OnboardingModal /> -- Turned off for now */}

      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} isCollapsed={isCollapsed} toggleCollapse={toggleCollapse} />

      {/* Main Content Wrapper */}
      <div className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${isCollapsed ? 'lg:ml-20' : 'lg:ml-72'}`}>
        
        {/* Top Header */}
        <header className="h-16 bg-white/80 backdrop-blur-md border-b border-slate-200 flex items-center justify-between px-4 sm:px-8 shrink-0 z-30 sticky top-0">
          <div className="flex items-center gap-4">
            <button 
              onClick={toggleSidebar}
              className="lg:hidden p-2 rounded-md text-slate-500 hover:bg-slate-100 hover:text-slate-700 transition-colors"
              aria-label="Toggle Navigation"
            >
              <FiMenu className="text-xl" />
            </button>
          </div>
          
          <div className="flex items-center gap-3 sm:gap-6">
            

            {actions && <div className="hidden sm:flex">{actions}</div>}
            
            <NotificationDropdown />
            
            <div className="h-8 w-px bg-slate-200 hidden sm:block"></div>
            
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 text-blue-700 border border-blue-300 flex items-center justify-center text-sm font-bold shadow-sm">
                {username ? username.substring(0, 2).toUpperCase() : 'U'}
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 bg-slate-50/50">
          <div className="max-w-7xl mx-auto">
            {children || <Outlet />}
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
